import { useEffect, useState } from 'react';

/**
 * @param {number} innerWidth desired min width to establish the viewport
 * @returns Boolean
 */
function useWindowWidth(innerWidth = 768) {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const handleResize = () => {
    setIsSmallScreen(window.innerWidth <= innerWidth);
  };

  useEffect(() => {
    handleResize(); // call only once at the beginning
    let timer;

    // throttledHandleResize will delay the execution of handleResize by 200 ms after
    // the resize event is triggered - will eliminate the unnecessary re-renders until the
    // resizing is settled.

    const throttledHandleResize = () => {
      clearTimeout(timer);
      timer = setTimeout(() => handleResize(), 200);
    };
    window.addEventListener('resize', throttledHandleResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', throttledHandleResize);
    };
  }, []);

  return { isSmallScreen };
}

export default useWindowWidth;
